import React from 'react';

export default function ToolsSettings() {
  return (
    <div>
      <h1 className="h4 mb-3">Tools Settings</h1>
      <p className="text-muted">Configure tool settings.</p>
    </div>
  );
}
